export const TOTAL_DEVICE_CLICK = "TOTAL_DEVICE_CLICK";
export const REFRESH_BTN_MONITOR = "REFRESH_BTN_MONITOR";
export const FILTER_BTN_VALUE = "FILTER_BTN_VALUE";
export const STATUS_BTN_VALUE = "STATUS_BTN_VALUE";
export const ACTIVE_VEHICLE_BTN_CLICK = "ACTIVE_VEHICLE_BTN_CLICK";
export const CLEAR_SOS_API_HIT = "CLEAR_SOS_API_HIT";
export const INVENTORY_STATS = "INVENTORY_STATS";
export const TICKET_STATS = "TICKET_STATS";
export const OFFLINE_INTIMATION_STATS = "OFFLINE_INTIMATION_STATS";
export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const VLTD_DAILY_STATS = "VLTD_DAILY_STATS";
export const VLTD_MONTHLY_STATS = "VLTD_MONTHLY_STATS";
export const VLTD_STATUS_STATS = "VLTD_STATUS_STATS";
export const VEHICLE_TYPE_WISE_STATS = "VEHICLE_TYPE_WISE_STATS";
export const EMERGENCY_STATS = "EMERGENCY_STATS";
export const OTHER_ALERTS_STATS = "OTHER_ALERTS_STATS";
export const CITIZEN_STATS = "CITIZEN_STATS";
export const MANUFACTURE_STATS = "MANUFACTURE_STATS";
export const BG_DETAIL_STATS = "BG_DETAIL_STATS";
export const RTO_STATEID_STATS = "RTO_STATEID_STATS";
export const RTO_STATS = "RTO_STATS";
export const VLTD_STATS_DASHBOARD = "VLTD_STATS_DASHBOARD";
export const CITIZEN_USERS = "CITIZEN_USERS";
export const CITIZEN_ALERT_SOS = "CITIZEN_ALERT_SOS";
export const CITIZEN_USERS_SOS = "CITIZEN_USERS_SOS";
export const CITIZEN_USERS_SOS_FILTER = "CITIZEN_USERS_SOS_FILTER";
export const GET_ROUTEFENCE = "GET_ROUTEFENCE";
export const GET_ROUTEFENCE_FILTER = "GET_ROUTEFENCE_FILTER";
export const GET_AREAFENCE = "GET_AREAFENCE";
export const MONITOR_DASHBOARD_STATS = "MONITOR_DASHBOARD_STATS";
export const MONITOR_DASHBOARD_DETAIL = "MONITOR_DASHBOARD_DETAIL";
export const SOS_PROVIDER_BY_LOCATION = "SOS_PROVIDER_BY_LOCATION";
export const LOCATE_TRAUMACENTER = "LOCATE_TRAUMACENTER";
export const GET_RTO_RFC = "GET_RTO_RFC";
export const EMERGENCY_DASHBOARD_DETAIL = "EMERGENCY_DASHBOARD_DETAIL";
export const TICKET_AMBULANCE = "TICKET_AMBULANCE";
export const TICKET_ALERTS = "TICKET_ALERTS";
export const RTO_WISE_STATS = "RTO_WISE_STATS";
export const TICKET_PENALTY_STATS = "TICKET_PENALTY_STATS";
export const TICKET_PENALTY_REVENUE_STATS = "TICKET_PENALTY_REVENUE_STATS";
export const TOP_PANIC_VEHICLES = "TOP_PANIC_VEHICLES";
export const EMERGENCY_DASHBOARD_STATS = "EMERGENCY_DASHBOARD_STATS";
export const TOP_PANIC_VEHICLES_DAILY = "TOP_PANIC_VEHICLES_DAILY";
export const TOP_TAMPER_ALERTS = "TOP_TAMPER_ALERTS";
export const GEO_TRACKING_DASHBOARD = "GEO_TRACKING_DASHBOARD";
export const GET_VEHICLES_FOR_TRACKING = "GET_VEHICLES_FOR_TRACKING";
export const GET_VEHICLE_GROUP = "GET_VEHICLE_GROUP";
export const GET_VEHICLES_BY_SEARCH = "GET_VEHICLES_BY_SEARCH";
export const ADD_VEHICLE_FOR_TRACKING = "ADD_VEHICLE_FOR_TRACKING";
export const GET_SCHOOL_ROUTE_ASSET_GROUP_VEHICLE_STATS =
  "GET_SCHOOL_ROUTE_ASSET_GROUP_VEHICLE_STATS";
